'use strict';

module.exports = require('nmr-predictor');
